import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { useAdminOrderStore } from "src/hooks/admin/order";
import System from "../../../helper/system";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import Helper from "../../../helper/Helper";
import noncancel from "src/assets/images/icon-non-cancel-black.png";
import Constants from "../../../helper/Constants";
import { useSystem } from "src/hooks/system";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { Tooltip } from 'src/component/Global/Tooltip';
import useReduxState from 'src/hooks/useReduxState';

const OrderInsightList = () => {
  const [{ orderInsightList, insightTotal, orderInsightInfo, orderTotalPrice }, { get_admin_order_insight_list, get_order_insight_export_all, }] = useAdminOrderStore();
  const [__check] = useAxiosIndicatorCheck();
  const gridRef = React.useRef();
  const [rowData, setRowData] = useState([]);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const { currencyType: { USD }, adminOrderEditEligibleStatus } = Constants
  const [, { get_quantity_format }] = useSystem();
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [updateOrderDetail, setUpdateOrderDetail] = useReduxState({ poNumber: '', billingAddress: {}, shippingAddress: {}, comment: '', erpPartNumbers: [], orderNumber: '' }, "updateAdminOrderDetails");
  const [saveButtonDisable, setSaveButtonDisable] = useReduxState(true, "saveButtonDisable");

  const urlParams = System.getParams();

  useEffect(() => {
    async function fetchHere() {
      __set("ADMIN_ORDER_LIST")
      await get_admin_order_insight_list(urlParams);
      __remove("ADMIN_ORDER_LIST")
    }

    fetchHere();
  }, []);

  const loadInformation = (e) => {
    return <>
      {e.value ? <span className="list-text-icon"><img className="img-fluid me-1" alt="Legend Information Icon" src={noncancel} /></span> : ""}
    </>
  }
  const [sortKey, setSortKey] = useState(0);
  const CustomHeader = (props) => {

    return (
      <div className="ag-cell-label-container" >
        <i className={`ag-icon ${props.column.getSort() === 'asc' ? 'ag-icon-asc' : props.column.getSort() === 'desc' ? 'ag-icon-desc' : 'ag-icon-none'}`} onClick={() => props.progressSort()} />
        <Tooltip
          opener={() => (
            <span className='cursor-pointer'>
              <i className="fa fa-pencil font-15 text-black-stone ms-2"></i>
            </span>
          )}
          content={() => ("Double click to edit any ERP part number.")}
        />
        <span className="ag-header-cell-text cursor-pointer" onClick={() => props.progressSort()}>{props.displayName}</span>
        <span className='cursor-pointer' onClick={(e) => { props.showColumnMenu(e.target) }}>
          <i className="ag-icon ag-icon-menu"></i>
        </span>
      </div>
    );
  };
  const columnDefs = useMemo(() => [
    {
      field: 'LineItemNumber',
      headerName: 'Line Item Number',
      headerTooltip: 'Line Item Number',
      sortable: true,
      maxWidth: 190,
      lockPosition: 'left',
      suppressMovable: true,
      unSortIcon: true,
      cellStyle: { textAlign: 'center' }
    },
    { field: 'PoNumber', hide: true, headerName: 'P.O. Number' },
    { field: 'OrderNumber', hide: true, headerName: 'Order Number' },
    { field: 'OrderStatus', hide: true, headerName: 'Order Status' },
    {
      field: 'ManufacturerName',
      headerName: 'Manufacturer',
      headerTooltip: 'Manufacturer',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'ManufacturerPartNumber',
      headerName: 'Manufacturer Part Number',
      headerTooltip: 'Manufacturer Part Number',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'MdmId',
      headerName: 'MDM Id',
      headerTooltip: 'MDM Id',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'CustomerPartNumber',
      headerName: 'Customer Part Number',
      headerTooltip: 'Customer Part Number',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'ErpPartNumber',
      headerName: 'ERP Part Number',
      headerTooltip: 'ERP Part Number',
      sortable: true,
      editable: adminOrderEditEligibleStatus?.includes(updateOrderDetail?.FSPOrderStatus) || false,
      minWidth: 220,
      unSortIcon: true,
      suppressMovable: true,
      headerComponent: CustomHeader,
      headerComponentParams: { sortKey },
      cellEditor: 'agTextCellEditor',
      cellEditorParams: {
        maxLength: 18
      }
    },

    {
      field: 'Quantity',
      headerName: 'Quantity',
      headerTooltip: 'Quantity',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'UnitPrice',
      headerName: 'Unit Price',
      headerTooltip: 'Unit Price',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    {
      field: 'TotalPrice',
      headerName: 'Total Line Price',
      headerTooltip: 'Total Line Price',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
    { field: 'OrderDate', hide: true, headerName: 'Order Date' },
    { field: 'OrderTotalPrice', hide: true, headerName: 'Order Total Price' },
    { field: 'AccountNumber', hide: true, headerName: 'Account Number' },
    { field: 'Buyer', hide: true, headerName: 'Buyer' },
    { field: 'RejectReason', hide: true, headerName: 'Reject Reason' },
    {
      field: 'Information',
      headerName: 'Information',
      headerTooltip: 'Information',
      cellRenderer: loadInformation,
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      suppressMovable: true,
    },
  ], [updateOrderDetail?.FSPOrderStatus, sortKey]);


  useEffect(() => {
    const data = orderInsightList?.map((_order) => {
      return {
        LineItemNumber: _order.lineItemNumber,
        PoNumber: orderInsightInfo?.poNumber,
        OrderNumber: (orderInsightInfo?.webOrderNumber ? "Web#:-" + orderInsightInfo.webOrderNumber : "") + (orderInsightInfo?.salesOrderNumber ? ",Sales#:-" + orderInsightInfo.salesOrderNumber : ""),
        OrderStatus: orderInsightInfo?.fspOrderState,
        ManufacturerName: _order.manufacturerName,
        ManufacturerPartNumber: _order.manufacturerPartNumber,
        MdmId: _order.mdmId,
        CustomerPartNumber: _order.customerPartNumber,
        ErpPartNumber: _order.erpPartNumber,
        Quantity: get_quantity_format(_order.quantity),
        UnitPrice: System.getFormatNumber({
          amount: Number(_order.unitPrice),
          isDisplaySymbol: false,
          currency: USD,
        }) || 0,
        TotalPrice: System.getFormatNumber({
          amount: Number(_order.totalPrice),
          maximumFractionDigits: 2,
          isDisplaySymbol: false,
          currency: USD,
        }) || 0,
        OrderDate: Helper.dateFormatFromString(orderInsightInfo?.orderDate) + "‎",
        OrderTotalPrice: System.getFormatNumber({
          amount: Number(orderTotalPrice),
          maximumFractionDigits: 2,
          isDisplaySymbol: false,
          currency: USD,
        }) || 0,
        Buyer: orderInsightInfo?.buyerContact?.buyerName,
        AccountNumber: orderInsightInfo?.paymentInfo?.accountNumber,
        RejectReason: orderInsightInfo?.rejectedReason,
        Information: Helper.valueIsNotNull(_order.ncnr) ? _order.ncnr : "",

      };
    });
    setRowData(data)
  }, [orderInsightList]);

  const exportAll = async (e) => {
    $('#emailFilter').removeClass('open');
    const data = await get_order_insight_export_all(urlParams);
    if (data?.Message) {
      system_alert_indicator({
        name: "accessDenied",
        message: data?.Message,
        type: "danger",
        isDisplayIcon: true,
        isDisplay: false
      });
    } else {
      Helper.downloadFileFromRes(data, 'line_items.csv');
    }
  }

  const exportFiltered = (e) => {
    $('#emailFilter').removeClass('open');
    const allColumnState = gridColumnApi?.getColumnState();
    const customColumns = allColumnState?.map((column) => column.colId);
    const params = { fileName: `line_items.csv`, sheetName: "Line Items", columnKeys: customColumns };
    gridRef.current?.api.exportDataAsCsv(params);
  }

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    setGridColumnApi(params.columnApi);
  }
  const changeMapRef = useRef({});

  const handleCellValueChanged = ({ oldValue, newValue, colDef, data, node }) => {
    const rowId = data.LineItemNumber;
    const field = colDef.field;

    const isString = typeof newValue === 'string';
    const finalValue = isString ? newValue.slice(0, 18) : newValue;

    if (isString && newValue.length > 18) {
      node.setDataValue(field, finalValue);
    }

    const columnChanges = changeMapRef.current[rowId] ||= {};

    columnChanges[field] = { oldValue, newValue: finalValue }
    const allChanges = Object.values(changeMapRef.current).flatMap(row =>
      Object.values(row).map(({ oldValue, newValue }) => ({ oldValue, newValue }))
    );

    setUpdateOrderDetail({ ...updateOrderDetail, erpPartNumbers: allChanges, isErpPartNumbersEdited: true })
    setSaveButtonDisable(false);
  };


  return (
    <>
      <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
        <div className="d-flex justify-content-start">
          Filtered Line Count: <b>{agGridFiltered}</b>
        </div>
        <div className="d-flex justify-content-end">
          Total Records: <b>{insightTotal}</b>
        </div>
      </div>
      <div className='bg-black p-2'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center'></div>
          <div className='d-flex align-items-center'>
            <span id="emailFilter" className="dropdown">
              <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
              </a>
              <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                <li><a href={void (0)} onClick={exportAll}>Export All</a></li>
                <li><a href={void (0)} onClick={exportFiltered}>Export Filtered</a></li>
              </ul>
            </span>
          </div>
        </div>
      </div>
      {__check("ADMIN_ORDER_LIST").status ? __check("ADMIN_ORDER_LIST").render : (orderInsightList?.length > 0 ?
        <div className="ag-theme-alpine ag-grd-hg mb-5">
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            suppressRowClickSelection={true}
            onGridReady={onGridReady}
            defaultColDef={{
              flex: 1,
              sortable: true,
              filter: true,
              enableRowGroup: true,
              enableValue: true,
              // lockPinned: true,
              resizable: true
            }}
            autoGroupColumnDef={{
              headerName: 'Group',
              minWidth: 220,
            }}
            onCellValueChanged={handleCellValueChanged}
            getRowNodeId={data => data.LineItemNumber}
            onSortChanged={() => setSortKey(prev => prev + 1)}
          >
          </AgGridReact>
        </div> : <div className='container mt-4'><NoResultContent
          message={`Sorry! No Result Found. We can't find any results based on your selection.`}
          isDisplay={false} /></div>)}
    </>
  );
}

export default OrderInsightList;